export const getPdfWorkerSrc = (
  nodeEnv: string | undefined = process.env.NODE_ENV,
) =>
  nodeEnv === 'test'
    ? './node_modules/pdfjs-dist/build/pdf.worker.min.js'
    : '/portal-ui/pdf.worker.min.mjs';
